<template>
    <div>
        <div class="page-title flex-row me-3 mt-3">
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">
                {{ $t('company_summaries') }}
            </h1>
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 py-3 my-1">
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary"><router-link :to="{ name: 'Home' }">{{ $t('home')
                            }}</router-link></a>
                </li>
                <li class="breadcrumb-item text-gray-600">{{ $t('company_summaries') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li>
            </ul>
        </div>
        <div class="content flex-row-fluid mt-4" id="kt_content">
            <div class="row">
                <div class="card mb-3 bgi-no-repeat bgi-position-y-top bgi-position-x-end shadow-sm bg-abstract-4">
                    <div class="card-body pt-0 pb-0">
                        <div class="d-flex flex-stack">
                            <div class="flex-grow">
                                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-1x justify-content-start align-items-start py-5 mb-2"
                                    role="tablist">
                                    <a class="fw-bold px-4 py-0 collapsible cursor-pointer rotate justify-content-end align-items-end shadow-sm rounded-1 collapsed border bg-light-primary"
                                        data-bs-toggle="collapse" data-bs-target="#kt_criterias">
                                        <span class="svg-icon svg-icon-3x rotate-180">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                    </a>
                                    <!-- <li class="nav-item" role="presentation">
                                        <div class="symbol symbol-45px me-5 justify-content-start">
                                            <i class="fas fa-filter fs-1 me-4 mt-2" style="color: rgb(0, 158, 247);"></i>
                                        </div>
                                    </li> -->
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link shadow-sm rounded-1 text-gray-600 py-3 text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 1}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 1, getSummaries()">{{ $t('daily')}}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link shadow-sm rounded-1 text-gray-600 py-3 text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 2}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 2, getSummaries()">{{ $t('weekly')}}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link shadow-sm rounded-1 text-gray-600 py-3 text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 3}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 3, getSummaries()">{{ $t('monthly')}}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link shadow-sm rounded-1 text-gray-600 py-3 text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 4}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 4, getSummaries()">{{ $t('yearly')}}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link rounded-1 text-gray-600 py-3 bg-light-primary text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 5}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 5, getSummaries()">{{ $t('by_branch')}}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link rounded-1 text-gray-600 py-3 bg-light-primary text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 6}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 6, getSummaries()">{{ $t('by_sales_channel') }}</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link rounded-1 text-gray-600 py-3 bg-light-primary text-active-primary fw-bold px-4"
                                            :class="{'active': form.report_type == 7}" data-bs-toggle="tab" href=""
                                            target="_self" @click="form.report_type = 7, getSummaries()">{{ $t('by_campaign') }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="collapse" id="kt_criterias">
                            <div class="row py-3">
                                <div class="col-lg-9">
                                    <div class="fv-row mb-4 row">
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('start_date') }}
                                            </label>
                                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }"
                                                v-maska="'##.##.####'" v-model="form.start_date"
                                                inputClassName="form-control" format="dd.MM.yyyy" autoApply
                                                :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'">
                                            </Datepicker>
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('end_date') }}
                                            </label>
                                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }"
                                                v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control"
                                                format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers
                                                :monthChangeOnScroll="'inverse'"></Datepicker>
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('vendor') }}
                                            </label>
                                            <Select2 v-model="form.vendor_id" :options="this.vendorList"
                                                :settings="{ width: '100%' }" />
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('sales_type') }}
                                            </label>
                                            <Select2 v-model="form.sales_type" :options="this.salesTypeList"
                                                :settings="{ width: '100%' }" />
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('branch') }}
                                            </label>
                                            <Select2 v-model="form.branch_id" :options="this.branchList"
                                                :settings="{ width: '100%' }" />
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('sales_channel') }}
                                            </label>
                                            <Select2 v-model="form.sales_channel_id" :options="this.salesChannelList"
                                                :settings="{ width: '100%' }" />
                                        </div>
                                        <div class="col-lg-3">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                {{ $t('campaign') }}
                                            </label>
                                            <Select2 v-model="form.campaign_id" :options="this.campaignList"
                                                :settings="{ width: '100%' }" />
                                        </div>
                                        <!-- <div class="col-lg-3">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            {{ $t('country') }}
                                        </label>
                                        <Select2 v-model="form.country" :options="this.countryList" :settings="{ width: '100%' }"/>
                                    </div> -->
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="d-flex justify-content-end mt-6" data-kt-customer-table-toolbar="base"
                                        v-if="this.$isCredentialActive(6,'R')">
                                        <Popper hover placement="top">
                                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3"
                                                @click="setCriteriasToDefault()">
                                                <i class="bi bi-eraser-fill fs-4"> </i>
                                            </button>
                                            <template #content>
                                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                            </template>
                                        </Popper>
                                        <button type="button" class="btn btn-sm btn-primary" @click="getSummaries()">
                                            <span class="svg-icon svg-icon-muted">
                                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor" />
                                                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5"
                                                        fill="currentColor" />
                                                    <rect opacity="0.3" width="12" height="3" rx="1.5"
                                                        fill="currentColor" />
                                                </svg>
                                            </span>
                                            <strong> {{ $t('list') }} </strong>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body p-0">
                        <DxChart id="chart" :data-source="summaries" :title="$t('company_summaries')+'('+previewDateList(this.form.start_date)+' - '+previewDateList(this.form.end_date)+')'" @pointClick="onPointClick($event)">
                            <DxCommonSeriesSettings argument-field="period" type="bar"
                                hover-mode="allArgumentPoints" selection-mode="allArgumentPoints">
                                <DxLabel :visible="true">
                                    <DxFormat :precision="0" type="fixedPoint" />
                                </DxLabel>
                            </DxCommonSeriesSettings>

                            <DxSeries value-field="sales" :name="$t('sales')" />
                            <DxSeries value-field="cost" :name="$t('cost')" />
                            <DxSeries value-field="profit" :name="$t('profit')" />

                            <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
                            <DxExport :enabled="true" :formats="['PNG', 'PDF', 'JPEG', 'SVG']" :file-name="userData.company_name +  $t('summary')  +'('+previewDateList(this.form.start_date)+' - '+previewDateList(this.form.end_date)+')'" />
                        </DxChart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 
<script>
  // Component Alias: `DSHF001`  
  import axios from 'axios';
  import moment from 'moment';
  import icons from '../../../assets/icons/icons.json';
  import { DxChart,DxSeries,DxCommonSeriesSettings,DxLegend,DxExport, DxLabel, DxFormat} from 'devextreme-vue/chart';

  
  export default {
    name: "CompanySummaries",
    components: { DxChart,DxSeries,DxCommonSeriesSettings,DxLegend,DxExport, DxLabel, DxFormat },
    data() {
        return { 
            form: {
                report_type: 3,
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                x_branch_id: '-1',
                x_sales_channel_id: '-1',
                x_campaign_id: '-1',
                vendor_id: '-1',
                sales_type: 0,
                branch_id: '-1',
                sales_channel_id: '-1',
                campaign_id: '-1',
                country: '-1',
                city: '-1',
                district: '-1',
            },
            userData: this.$getUser(),
            icons: icons,
            documents: [],
            menuSelection: '/CompanySummariesHelppage',
            iconView: false,
            salesTypeList: [
                { id: 0, text: this.$t('all')},
                { id: 1, text: this.$t('domestic')},
                { id: 2, text: this.$t('overseas')},
            ],
            summaries : [],
            branchList: [],
            salesChannelList :  [],
            campaignList :  [],
            countryList : [],
            currencyList : [],
        };
    },
    computed: { 
        previewDate(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY HH:mm')
            }
            }
        },
        previewDateList(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
            }
            }
        },
    },
    methods: {
        getData() { 
            const parametersOne = { 
                session_id: this.$getUser().session_id,
                list_name: ["branch", "sales_channel","campaign"], //"country", "currency"
            };
            const parametersTwo = {
                account_id: this.$getSessionStorage('record_id'),
                session_id: this.$getUser().session_id,
                supplier_account_type: -1, //ALL
            }; 
            const parametersThree = {
                session_id: this.$getUser().session_id,
                supplier_account_type: 3, //Sales Vendors
            }; 
            const requestOne = axios.post('/api/Helper/GeneralLists', parametersOne, {'Content-Type': 'application/json'});
            const requestTwo=  axios.post('/api/GetCompanyAccounts/GetCustomerVendorsByAccountId', parametersTwo, {'Content-Type': 'application/json'}); 
            const requestThree =  axios.post('/api/GetCompanyAccounts/GetPolicyAccounts', parametersThree, {'Content-Type': 'application/json'});  
            axios.all([requestOne, requestTwo,requestThree]).then(axios.spread((...responses) => {
                this.branchList = responses[0].data.branch;
                this.salesChannelList = responses[0].data.sales_channel;
                this.campaignList = responses[0].data.campaign;
                this.vendorList = responses[2].data;
                
                this.branchList.unshift({id:'-1' , text : this.$t('all')});
                this.salesChannelList.unshift({id:'-1' , text : this.$t('all')});
                this.campaignList.unshift({id:'-1' , text : this.$t('all')});
                this.vendorList.unshift({id:'-1' , text : this.$t('all')});
                this.getSummaries();
            }))
            .catch(errors => { 
                console.error(errors); 
            })
        },
        async helpPageViewIcon()
        {
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/DocumentHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        },
        getSummaries() {
            const params = {
                session_id : this.$getUser().session_id,
                report_type: this.form.report_type,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                x_branch_id: this.form.x_branch_id !== '-1' ? this.form.x_branch_id : null,
                x_sales_channel_id: this.form.x_sales_channel_id !== '-1' ? this.form.x_sales_channel_id : null,
                x_campaign_id: this.form.x_campaign_id !== '-1' ? this.form.x_campaign_id : null,
                vendor_id: this.form.vendor_id !== '-1' ? this.form.vendor_id : null,
                sales_type: this.form.sales_type,
                branch_id: this.form.branch_id !== '-1' ? this.form.branch_id : null,
                sales_channel_id: this.form.sales_channel_id !== '-1' ? this.form.sales_channel_id : null,
                campaign_id: this.form.campaign_id !== '-1' ? this.form.campaign_id : null,
                country: this.form.country,
                city: this.form.city,
                district: this.form.district,
            };
            axios.post('/api/Transaction/GetSummaries',params,{'Content-Type' : 'Application/json'}).then((response) =>{
                this.summaries = response.data;
            })
            .catch((error)=>{
                console.error(error);
            })
        },
        setCriteriasToDefault() {
            this.form = {
                report_type: 3,
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                x_branch_id: '-1',
                x_sales_channel_id: '-1',
                x_campaign_id: '-1',
                vendor_id: '-1',
                sales_type: 0,
                branch_id: '-1',
                sales_channel_id: '-1',
                campaign_id: '-1',
                country: '-1',
                city: '-1',
                district: '-1',
            },
            this.summaries = [];
        },
        onPointClick(event) {
            event.target.select();
        }
    },
    created() {
        this.helpPageViewIcon();
        this.getData();
    }
  }; 
</script>

  

<style type="text/css">
     #chart{
        /* background-color: #F8F5FF; */
        padding: 10px;
    } 
   
</style>